export type LocaleId = string;

export type Localized<T> = Record<LocaleId, T>;

export default function getLocalized<T>(localized: Localized<T>, locale: LocaleId): T | undefined {
  return localized[locale];
}
